<div class="actions glyphicon glyphicon-trash" (click)="removeDocument()"></div>




